import React from "react";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

export default function FooterComponent({ setSubmitted }) {


  return (
    <div>
      <div className="footer">
        <div className="container-xl pt-3">
          <div className="row">
            <div className="col-md-6 flex-around">
              <p>Globility / GlobalMatch</p>
              <p>Takkebijsters 57</p>
            </div>
            <div className="col-md-6 flex-around">
              <p>4817BL Breda</p>
              <p><a href="tel:+31621509236">+31 (0) 639533622</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
